export default __webpack_public_path__ + "static/media/Giz-German-India-Cooperation.2dcb30d8.png";